import {Grid} from "@material-ui/core";
import * as PropTypes from "prop-types";
import React, {useState} from "react";
import {BEAUFTRAGTER, BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBD} from "../../../consts/funktionaleRollen";
import {logger} from "../../../services/LogService";
import {
    getBauwerkAnlageteilBezeichnungEndpoint,
    getBauwerkAnlageteilKategorieEndpoint,
    getBauwerkBezeichnerEndpoint,
    getBauwerkEinheitEndpoint,
} from "../../../services/WertelistenService";
import {createCalculatedColumn, createComponentColumn, createNumberColumn} from "../../../utils/ColumnUtils";
import {useForm} from "../../../utils/FormUtils";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {nullableNumber, requiredNumber, requiredWerteListeObjekt} from "../../../utils/Validator";
import EAAccordion from "../../EAAccordion";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import EADialog from "../../EADialog";
import EATable from "../../EATable";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import {useHttpSortById} from "../../../utils/usePreformattedHttp";
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import {confirmDeleteOption} from "../../ConfirmationDialog/confirmationDialogOptions";

function TableDialog(props) {
    const [kategorieOptionen] = useHttpSortById(getBauwerkAnlageteilKategorieEndpoint);
    const [bezeichnungOptionen] = useHttpSortById(getBauwerkAnlageteilBezeichnungEndpoint);
    const [bezeichnerOptionen] = useHttpSortById(getBauwerkBezeichnerEndpoint);
    const [bezeichnerEinheitOptionen] = useHttpSortById(getBauwerkEinheitEndpoint);

    return (
        <EADialog
            open={props.open}
            titleChildren={"Anlagenteil"}
            content={
                <div style={{width: "600px"}}>
                    <div className="gridl" style={{gridTemplateColumns: "auto auto"}}>
                        {props.formFactory.renderAutocompleteWerteliste(
                            "kategorie",
                            "kategorie",
                            "Kategorie",
                            kategorieOptionen,
                            false,
                            false,
                            null,
                            [
                                {
                                    id: "bezeichnung",
                                    calcDependentVal: () => {
                                        return null;
                                    },
                                },
                            ]
                        )}
                        {props.formFactory.renderAutocompleteWerteliste("bezeichnung", "bezeichnung", "Bezeichnung", bezeichnungOptionen)}
                        {props.formFactory.renderNumberInput("anzahl", "anzahl", "Anzahl")}
                        {props.formFactory.renderAutocompleteWerteliste("bezeichner", "bezeichner", "Bezeichner", bezeichnerOptionen)}
                        {props.formFactory.renderNumberInput("bezeichnerGroesse", "bezeichnerGroesse", "Wert/Größe")}
                        {props.formFactory.renderAutocompleteWerteliste(
                            "bezeichnerEinheit",
                            "bezeichnerEinheit",
                            "Einheit",
                            bezeichnerEinheitOptionen
                        )}
                        {props.formFactory.renderInput("bemerkung", "bemerkung", "Bemerkung", "text", false, {
                            multiline: true,
                            rows: 10,
                            style: {gridColumnEnd: "span 2"},
                        })}
                    </div>
                </div>
            }
            buttons={
                <EAButtonBar>
                    <EAButton
                        id={"btnBauwerkAbbrechen"}
                        data-cy={"btnBauwerkAbbrechen"}
                        label={"Abbrechen"}
                        onClick={props.onClickCancel}
                    />
                    <EAButton id={"btnBauwerkOk"} data-cy={"btnBauwerkOk"} color="primary" label={"Übernehmen"} onClick={props.onClickOk}/>
                </EAButtonBar>
            }
        />
    );
}

TableDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    formFactory: PropTypes.any.isRequired,
    data: PropTypes.any.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickOk: PropTypes.func.isRequired,
};
export default function Bauwerke(props) {
    const confirm = useConfirmation();
    const dataName = "bauwerke";
    const [tableIndex, setTableIndex] = useState(-1);
    const schema = {
        kategorie: requiredWerteListeObjekt(),
        bezeichnung: requiredWerteListeObjekt(),
        anzahl: requiredNumber(),
        bezeichnerGroesse: nullableNumber(),
    };
    const {values, setValues, formFactory, validate} = useForm({
        initialValues: {
            kategorie: null,
            bezeichnung: null,
            anzahl: 0,
            bezeichner: null,
            bezeichnerGroesse: 0.0,
            bezeichnerEinheit: null,
            bemerkung: "",
        },
        onSubmit() {
        },
        schema,
    });
    const [dlgOpen, setDlgOpen] = useState(false);

    function handleDelete(index) {
        if (isDisabled()) {
            return;
        }

        confirm(
            confirmDeleteOption(
                "den Anlagenteil",
                () => removeBauwerk(index),
                () => {
                }
            )
        );
    }

    function removeBauwerk(index) {
        const tableData = [...props.data];
        tableData.splice(index, 1);
        setValues({});
        props.onChange(dataName, tableData);
    }

    function handleClickOpen() {
        setDlgOpen(true);
    }

    function handleClose() {
        setDlgOpen(false);
        setTableIndex(-1);
        setValues({});
    }

    function handleEdit(index) {
        if (isDisabled()) {
            return;
        }
        setTableIndex(index);
        setValues(props.data[index]);
        handleClickOpen();
    }

    function handleCloseOk() {
        const e = validate();
        if (e && Object.keys(e).length > 0) {
            return;
        }
        setDlgOpen(false);
        const tableData = [...props.data];
        if (tableIndex === -1) {
            tableData.push({...values});
        } else {
            tableData[tableIndex] = {...values};
        }
        logger.debug(dataName + "Close", tableData);
        setTableIndex(-1);
        setValues({});
        props.onChange(dataName, tableData);
    }

    function isDisabled() {
        if (!props.parentId) return false;
        if (props.modus === "l") {
            return true;
        }
        if (props.modus === "s") {
            return !userHasAnyRole([BETREIBER, BEAUFTRAGTER, FACHADMIN, SYSTEMADMIN, ZUST_SBD]);
        }
        return true;
    }

    return (
        <React.Fragment>
            <TableDialog
                formFactory={formFactory}
                open={dlgOpen}
                onClickCancel={handleClose}
                data={{...values}}
                onClickOk={handleCloseOk}
            />
            <div className="tabsheet-content-margin">
                <EAAccordion
                    label={`Anlagenteile (${props.data ? props.data.length : 0})`}
                    className="gridl accordionPadding"
                    id="bauwerkeAccordion"
                    variant="light"
                    expanded={true}
                    expandIcon={null}
                >
                    <EATable
                        id="bauwerke"
                        initialSortColumn="kategorie"
                        columns={[
                            createComponentColumn(
                                "actions",
                                (row, index) => {
                                    if (isDisabled()) return <div/>;
                                    return (
                                        <Grid container spacing={1} justify="center">
                                            <Grid item>
                                                <EATableActionButton id={"editAuslegung-" + index} iconName="ico-edit">
                                                    <span
                                                        onClick={() => handleEdit(index)}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                            <Grid item>
                                                <EATableActionButton id={"deleteAuslegung-" + index} iconName="ico-delete">
                                                    <span
                                                        onClick={() => handleDelete(index)}
                                                        className={"w-100"}
                                                        style={{
                                                            height: "100%",
                                                            display: "block",
                                                        }}
                                                    />
                                                </EATableActionButton>
                                            </Grid>
                                        </Grid>
                                    );
                                },
                                "",
                                null,
                                {width: "50px", minWidth: "50px", padding: "0"}
                            ),
                            createCalculatedColumn(
                                "kategorie",
                                (row) => {
                                    return row.kategorie && row.kategorie.value ? row.kategorie.value : "";
                                },
                                "Kategorie"
                            ),
                            createCalculatedColumn(
                                "bezeichnung",
                                (row) => {
                                    return row.bezeichnung && row.bezeichnung.value ? row.bezeichnung.value : "";
                                },
                                "Bezeichnung"
                            ),
                            createNumberColumn("anzahl", "Anzahl", {padding: "0"}),
                            createCalculatedColumn(
                                "bezeichner",
                                (row) => {
                                    return row.bezeichner && row.bezeichner.value ? row.bezeichner.value : "";
                                },
                                "Bezeichner"
                            ),
                            createNumberColumn("bezeichnerGroesse", "Wert/Größe", {padding: "0"}),
                            createCalculatedColumn(
                                "bezeichnerEinheit",
                                (row) => {
                                    return row.bezeichnerEinheit && row.bezeichnerEinheit.value ? row.bezeichnerEinheit.value : "";
                                },
                                "Einheit",
                                {padding: "0"}
                            ),
                        ]}
                        data={props.data}
                    />
                    {props.formFactory.renderButton(
                        "addAuslegung",
                        "addAuslegung",
                        "Hinzufügen",
                        () => {
                            setTableIndex(-1);
                            handleClickOpen();
                        },
                        {
                            style: {placeSelf: "end"},
                        }
                    )}
                </EAAccordion>
            </div>
        </React.Fragment>
    );
}

Bauwerke.propTypes = {
    data: PropTypes.any,
    parentId: PropTypes.number,
    modus: PropTypes.string,
    formFactory: PropTypes.any,
    onChange: PropTypes.func,
};
